import React from 'react';
import ReactRelay, {
  createFragmentContainer,
  graphql,
} from 'react-relay';
import withStyles from "@material-ui/core/styles/withStyles";
import { NavLink, Link } from "react-router-dom";
import cx from "classnames";
import Build from "@material-ui/icons/Map";
import StrategyIcon from "@material-ui/icons/Layers";
import BigGoalIcon from "@material-ui/icons/Map";
import StepGoalIcon from "@material-ui/icons/LocalMovies";
import ActionPlanIcon from "@material-ui/icons/LocalMall";
import History from "@material-ui/icons/History";
import Timeline from "@material-ui/icons/Timeline";
import Add from "@material-ui/icons/NoteAdd";
import People from "@material-ui/icons/People";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import {getPath, maxStrDisplay, recursivePath, disableLink} from "local-util"
import Dummy from "components/Dummy"
import sidebarStyle from "assets/material-admin/assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";


class Plans extends React.Component {
  constructor(props) {
    super(props)
  }
  doesMatchInPath(id) {
    const path = this.props.activePath

    return path.some((e) => {
      return id == e.id
    })
  }
  activeStrategies(company) {
    if (company.strategies) {
      return company.strategies.filter((s) => {
        return s.status == "ACTIVE" && !s.isCoaching
      })
    }
  }
  render() {
    const {classes, router, companyId} = this.props
    const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
              this.props.miniActive && this.state.miniActive,
            });
    const item = this.props.item
    const children = item ? ((item.strategies && this.activeStrategies(item)) || item.bigGoals || item.stepGoals || item.actionPlans) : null

    if (!item) {
      return <span/>
    }

    let iconType

    const listItemActiveClasses = this.doesMatchInPath(item.id) ? {root: classes.itemActive} : {}
    const childrenView = (children ?
                          (
                            <List className={classes.list}>
                              <Collapse in={!!item.strategies || this.doesMatchInPath(item.id)} >
                                {children.map((c) => {
                                  return <Plans
                                           planLink={this.props.planLink}
                                           onClick={this.props.onClick}
                                           env={this.props.env}
                                           companyId={companyId}
                                           router={router}
                                           key={c.id} {...c}
                                           activePath={this.props.activePath}
                                           item={c}
                                           classes={classes} />
                                })}
                              </Collapse>
                            </List>
                          ) : <span/>)

    let offsetItemText = ""
    let offsetIcon = ""
    let maxDisplay = 17

    if (item.stepGoals) {
      offsetItemText = classes.itemTextBigGoal
      offsetIcon = classes.itemIconBigGoal
      maxDisplay = 15
      iconType = <span/> //<BigGoalIcon/>
    } else if (item.actionPlans) {
      offsetItemText = classes.itemTextStepGoal
      offsetIcon = classes.itemIconStepGoal
      iconType = <span/> //<StepGoalIcon/>
      maxDisplay = 15
    } else if (item.bigGoals) {
      iconType = <StrategyIcon/>
    }
    else if (!children) {
      offsetItemText = classes.itemTextActionPlan
      offsetIcon = classes.itemIconActionPlan
      maxDisplay = 15
      iconType = <span/> //<ActionPlanIcon/>
    }

    return (
      (item.strategies ?
       (<span>
        {childrenView}
        </span>)
       :
       (
         <ListItem
            className={classes.item}>
           <ListItemIcon className={classes.itemIcon + " " + offsetIcon}>
             {iconType}
           </ListItemIcon>
           <a style={{color: "inherit"}}  onClick={disableLink} href={this.props.planLink(item)}>
             {/* This span is required to make sure a first-child css gets overwritten */}
             <span/>
           <ListItemText
              onClick={()=> {
                this.props.onClick(item)
             }}
             disableTypography={true}
             secondary={<b
                             className={
                               classes.caret +
                                 " " +
                                 (this.doesMatchInPath(item.id) ? classes.caretActive : "")
                             }
                             />
             }
             primary={maxStrDisplay(item.name, maxDisplay)}
             className={itemText + " " + (this.doesMatchInPath(item.id) ? classes.itemActive : "")
             + " " + offsetItemText}>

         </ListItemText>
         </a>
           {childrenView}
         </ListItem>

       )
      )
    )
  }
}

class CoachingPlans extends React.Component {
  constructor(props) {
    super(props)
  }
  doesMatchInPath(id) {
    const path = this.props.activePath

    return path.some((e) => {
      return id == e.id
    })
  }
  activeStrategies(company) {
    if (company.strategies) {
      return company.strategies.filter((s) => {
        return s.status == "ACTIVE" && s.isCoaching
      })
    }
  }
  render() {
    const {classes, router, companyId} = this.props
    const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
              this.props.miniActive && this.state.miniActive,
            });
    const item = this.props.item
    const children = item ? ((item.strategies && this.activeStrategies(item)) || item.stepGoals || item.actionPlans) : null

    if (!item) {
      return <span/>
    }

    let iconType

    const listItemActiveClasses = this.doesMatchInPath(item.id) ? {root: classes.itemActive} : {}
    const childrenView = (children ?
                          (
                            <List className={classes.list}>
                              <Collapse in={!!item.strategies || this.doesMatchInPath(item.id)} >
                                {children.map((c) => {
                                  return <CoachingPlans
                                           planLink={this.props.planLink}
                                           onClick={this.props.onClick}
                                           env={this.props.env}
                                           companyId={companyId}
                                           router={router}
                                           key={c.id} {...c}
                                           activePath={this.props.activePath}
                                           item={c}
                                           classes={classes} />
                                })}
                              </Collapse>
                            </List>
                          ) : <span/>)

    let offsetItemText = ""
    let offsetIcon = ""
    let maxDisplay = 17

    if (item.stepGoals) {
      offsetItemText = classes.itemTextBigGoal
      offsetIcon = classes.itemIconBigGoal
      maxDisplay = 15
      iconType = <span/> //<BigGoalIcon/>
    } else if (item.actionPlans) {
      offsetItemText = classes.itemTextStepGoal
      offsetIcon = classes.itemIconStepGoal
      iconType = <span/> //<StepGoalIcon/>
      maxDisplay = 15
    } else if (item.bigGoals) {
      iconType = <StrategyIcon/>
    }
    else if (!children) {
      offsetItemText = classes.itemTextActionPlan
      offsetIcon = classes.itemIconActionPlan
      maxDisplay = 15
      iconType = <span/> //<ActionPlanIcon/>
    }

    return (
      (item.strategies ?
       (<span>
        {childrenView}
        </span>)
       :
       (
         <ListItem
            className={classes.item}>
           <ListItemIcon className={classes.itemIcon + " " + offsetIcon}>
             {iconType}
           </ListItemIcon>
           <a style={{color: "inherit"}}  onClick={disableLink} href={this.props.planLink(item)}>
             {/* This span is required to make sure a first-child css gets overwritten */}
             <span/>
           <ListItemText
              onClick={()=> {
                this.props.onClick(item)
             }}
             disableTypography={true}
             secondary={<b
                             className={
                               classes.caret +
                                 " " +
                                 (this.doesMatchInPath(item.id) ? classes.caretActive : "")
                             }
                             />
             }
             primary={maxStrDisplay(item.name, maxDisplay)}
             className={itemText + " " + (this.doesMatchInPath(item.id) ? classes.itemActive : "")
             + " " + offsetItemText}>

         </ListItemText>
         </a>
           {childrenView}
         </ListItem>

       )
      )
    )
  }
}

class MainPlans extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activePathId: props.params.strategyId || props.params.bigGoalId || props.params.stepGoalId || props.params.actionPlanId
    }
  }

  activeStrategy(company) {
    if (company && company.strategies && company.strategies.length > 1) {
      return company.strategies.find((c) => {
        return c.status == "ACTIVE"
      })
    } else {
      if (company && company.strategies && company.strategies.length == 1) {
        return company.strategies[0]
      } else {
        return null
      }
    }
  }
  isInactiveStrategy(company) {
    if (company && company.strategies) {
      return company.strategies.some((c) => {
        return c.status == "DEACTIVE"
      })
    } else {
      return false
    }
  }
  planFromProps(company) {
    const params = this.props.params
    const activePropId = this.state.activePathId

    if (company && company.strategies && activePropId) {
      let pathObjs = {}
      let path = recursivePath(company, [], pathObjs)

      return pathObjs[activePropId]
    } else {
      return null
    }
  }
  getPath(company) {
    if (!company) {
      return null
    } else {
      const fromProps = this.planFromProps(company)

      if (fromProps) {
        return fromProps
      }

      const planType = this.props.route.planType

      if (planType) {
        const p = this.props[planType]

        return p && p.path && JSON.parse(p.path)
      } else {
        return []
      }
    }
  }

  componentDidUpdate(prevProps) {
    const oldId = prevProps.params.strategyId || prevProps.params.bigGoalId || prevProps.params.stepGoalId || prevProps.params.actionPlanId
    const newId = this.props.params.strategyId || this.props.params.bigGoalId || this.props.params.stepGoalId || this.props.params.actionPlanId
    if (oldId != newId) {
      this.setState({activePathId: newId})
    }
  }
  isUser() {
    let e = this.props.profile1.employment.find((e) => {
      return e.companyId == this.props.activeCompany.id
    })

    return e && e.employeeRole == 'USER'

  }
  filterStrategies(company, profile) {
    let c = JSON.parse(JSON.stringify(company));
    const companyEmployment = profile.employment.find(e => e.companyId == company.id)
    const employeeId = companyEmployment.employeeId
    let strategies = company.strategies.filter(s => {
      return !s.employees.every(se => se.id != employeeId);
    })
    c.strategies = strategies;
    return c
  }
  render() {
    
    const isAdmin = this.props.profile1.isSuperadmin || this.props.profile1.employment.find((e) => {
      return e.companyId == this.props.activeCompany.id && e.employeeRole == 'ADMIN'
    })
    let item = isAdmin ? this.props.activeCompany : this.filterStrategies(this.props.activeCompany, this.props.profile1)
    const activePath = this.getPath(item)
    const companyId = item.id
    const {classes, router} = this.props
    const activeStrategy = this.activeStrategy(item)
    const isInactiveStrategy = this.isInactiveStrategy(item)    
    const employeeLink = `/company/${companyId}/employee`
    const activeStrategyLink = activeStrategy ? `/company/${companyId}/timeline/${activeStrategy.id}` : ""
    const companyArchiveLink = `/company/${companyId}/archive`
    const createStrategyLink = `/company/${companyId}/createStrategy`
    const createCoachingStrategyLink = `/company/${companyId}/createCoachingStrategy`
    const planLink = (item) => {
      let type = "actionPlan"
      if (item.bigGoals && !item.isCoaching)  {
        type = "strategy"
      } else if (item.bigGoals && item.isCoaching)  {
        type = "coachingstrategy"
      } else if (item.stepGoals) {
        type = "bigGoal"
      } else if (item.actionPlans) {
        type = "stepGoal"
      }
      return `/company/${companyId}/${type}/${item.id}`
    }
    return (
      !item ? <span/> :
        ([
          (
            <List key="otherCompanyItems" className={classes.list}>
              {!isAdmin ? <span/> :

               <a style={{color: "inherit"}} onClick={disableLink} href={employeeLink}>
                 <ListItem
                   className={classes.item}>
                   <ListItemIcon className={classes.itemIcon}>
                     <People/>
                   </ListItemIcon>
                   <ListItemText
                     onClick={()=> {
                       this.props.router.push(employeeLink)
                       return false
                     }}
                     disableTypography={true}
                     primary="Employees"
                     className={classes.itemText}>
                   </ListItemText>
               </ListItem>
               </a>
              }
              {!isAdmin ? <span/> :
               <a style={{color: "inherit"}} onClick={disableLink} href={createStrategyLink}>
                 <ListItem
                   className={classes.item}>
                   <ListItemIcon className={classes.itemIcon}>
                     <Add/>
                   </ListItemIcon>
                   <ListItemText
                     onClick={()=> {
                       this.props.router.push(createStrategyLink)
                     }}
                     disableTypography={true}
                     primary="Create Strategy"
                     className={classes.itemText}>
                   </ListItemText>
                 </ListItem>
               </a>

              }
              {!isAdmin ? <span/> :
               <a style={{color: "inherit"}} onClick={disableLink} href={createStrategyLink}>
                 <ListItem
                   className={classes.item}>
                   <ListItemIcon className={classes.itemIcon}>
                     <Add/>
                   </ListItemIcon>
                   <ListItemText
                     onClick={()=> {
                       this.props.router.push(createCoachingStrategyLink)
                     }}
                     disableTypography={true}
                     primary="Create Coaching Plan"
                     className={classes.itemText}>
                   </ListItemText>
                 </ListItem>
               </a>

              }
              
              {activeStrategy ?
               <a style={{color: "inherit"}} onClick={disableLink} href={activeStrategyLink} >
                 <ListItem
                 className={classes.item}>
                 <ListItemIcon className={classes.itemIcon}>
                   <Timeline/>
                 </ListItemIcon>
                 <ListItemText
                   onClick={()=> {
                     this.props.router.push(activeStrategyLink)
                   }}
                   disableTypography={true}
                   primary="Timeline"
                   className={classes.itemText}>
                 </ListItemText>
               </ListItem>
               </a>
               :
               <span/>}
            </List>
          ),
          (
            <List key="activePlans" className={classes.list}>
              <Plans
                planLink={planLink}
                 onClick={(item) => {
                   this.setState({activePathId: item.id})
                   router.push(planLink(item))
                }}
                companyId={item.id}
                item={item}
                activePath={activePath}
                router={this.props.router}
                classes={this.props.classes}
                />
            </List>
          ),
          (
            <List key="activeCoachingPlans" className={classes.list}>
              <CoachingPlans
                planLink={planLink}
                onClick={(item) => {
                  this.setState({activePathId: item.id})
                  router.push(planLink(item))
                }}
                companyId={item.id}
                item={item}
                activePath={activePath}
                router={this.props.router}
                classes={this.props.classes}
              />
            </List>
          ),
          (
            !isInactiveStrategy ?
             <span key="inactive"/>
             :
              (<List key="inactiveStrategies" className={classes.list}>
                 <a style={{color: "inherit"}} onClick={disableLink} href={companyArchiveLink}>
                   <ListItem
                     className={classes.item}>
                     <ListItemIcon className={classes.itemIcon}>
                       <History/>
                     </ListItemIcon>
                     <ListItemText
                       onClick={()=> {
                         this.props.router.push(companyArchiveLink)
                       }}
                       disableTypography={true}
                       primary="Inactive Strategies"
                       className={classes.itemText}>
                     </ListItemText>
                   </ListItem>
                 </a>
               </List>)

          )
        ])

    )
  }
}

createFragmentContainer(Dummy, {
  companies: graphql`
fragment ActiveCompany_companies on User {
 id
 activeCompanyId
 companies {
   name
   id
   state {
    name
    attr
    value
   }
   strategies {
    status
    id
    path
    isCoaching
    employees {
      id
    }
    stepGoals {
        name
        path
        status
        index
        id
        actionPlans {
          path
          name
          status
          index
          id
        }
      }
    name
    bigGoals {
      id
      index
      path
      name
      status
      stepGoals {
        name
        path
        status
        index
        id
        actionPlans {
          path
          name
          status
          index
          id
        }
      }
    }
  }
 }
}
`,
  activeCompany: graphql`
fragment ActiveCompany_activeCompany on Company {
   name
   id
   state {
    name
    attr
    value
   }
   strategies {
    status
    id
    path
    isCoaching
    employees {
      id
    }
    stepGoals {
        name
        path
        status
        index
        id
        actionPlans {
          path
          name
          status
          index
          id
        }
      }
    name
    bigGoals {
      id
      index
      path
      name
      status
      stepGoals {
        name
        path
        status
        index
        id
        actionPlans {
          path
          name
          status
          index
          id
        }
      }
    }
  }
}`
})

export default withStyles(sidebarStyle)(MainPlans)
